import { createFileRoute } from '@tanstack/react-router';
import { motion } from 'framer-motion';
import { BackgroundWaves } from '@/components/BackgroundWaves';
import { PromptInput } from '@/components/PromptInput';
import styles from './index.module.scss';

export const Route = createFileRoute('/')({
  component: HomePage,
});

function HomePage() {
  return (
    <div className={styles.home}>
      <BackgroundWaves />
      <motion.div
        className={styles.home__hero}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className={styles.home__title}>Learn Smarter, Not Harder</h1>
        <p className={styles.home__subtitle}>
          Generate personalized quiz questions on any topic and build your knowledge through daily review
        </p>
      </motion.div>

      <motion.div
        className={styles.home__promptSection}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.1 }}
      >
        <PromptInput />
      </motion.div>
    </div>
  );
}
